import { createApp, configureCompat } from 'vue'
import VueCookies from 'vue-cookies'
import VueMathjax from 'vue-mathjax-next'
import mitt from 'mitt'
import App from './App.vue'
import router from './router'
import store from './store'

// Import Design System CSS
import '@sekolahmu/sekolahmu-design-system-next/dist/component.css'
import '@sekolahmu/sekolahmu-design-system-next/dist/style.css'

// Import CSS
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'cropperjs/dist/cropper.css'
import '@vuepic/vue-datepicker/dist/main.css'

// Import Plugins
import './plugin/vue-meta'
import './plugin/vue-bootstrap'
import './plugin/fontawesome'

// Import Global Function
import XSSFilter from '@/functions/XSSFilter'
import axiosServer from '@/configs/axiosServer'
import axiosServerGolang from '@/configs/axiosServerGolang'

// Import Layout
import './layouts/'

// Import Firebase
import firebaseConfig from './modules/firebase.config'
import * as firebase from 'firebase/app'
import 'firebase/analytics'
import 'firebase/messaging'
import 'firebase/firestore'

// Import Components
import SDesignSystem from '@sekolahmu/sekolahmu-design-system-next/dist/component.common'
import BModalKariermu from '@/components/molecules/modals/BModalKariermu.vue'
import BTabsKariermu from '@/components/molecules/tabs/BTabsKariermu.vue'
import BCollapseKariermu from '@/components/molecules/collapse/BCollapseKariermu.vue'
import BSpinnerKariermu from '@/components/atoms/spinner/BSpinnerKariermu.vue'
import { createHead } from '@unhead/vue'
import VueDatePicker from '@vuepic/vue-datepicker';

// Import Directives
import BCollapseKariermuToggleDirective from './directives/vToggleBCollapseKariermu'

configureCompat({
  RENDER_FUNCTION: true
})
const emitter = mitt()
const Vue = createApp(App)
const head = createHead()

Vue.use(router)
Vue.use(store)

// Plugins
Vue.use(SDesignSystem)
Vue.use(VueCookies)
Vue.use(VueMathjax)
Vue.use(head)

// Global Components
Vue.component('b-modal-kariermu', BModalKariermu)
Vue.component('b-tabs-kariermu', BTabsKariermu)
Vue.component('b-collapse-kariermu', BCollapseKariermu)
Vue.component('b-spinner-kariermu', BSpinnerKariermu)
Vue.component('VueDatePicker', VueDatePicker);

// Global Directives
Vue.directive('toggle-collapse', BCollapseKariermuToggleDirective)

// Global Functions
Vue.config.globalProperties.$XSSFilter = XSSFilter
Vue.config.globalProperties.$axiosServer = axiosServer
Vue.config.globalProperties.$axiosServerGolang = axiosServerGolang
Vue.config.globalProperties.emitter = emitter

// Firebase
const firebaseApp = firebase.initializeApp(firebaseConfig)
window.firebase = firebase
window.firebaseAnalytics = firebaseApp.analytics()
window.firestore = firebaseApp.firestore()

if (firebaseApp.firebase_.messaging.isSupported()) {
  window.firebaseMessaging = firebaseApp.messaging()
}

// Hotjar
// timeout to wait for user info to be loaded
setTimeout(() => {
  const { userInfo, isLogin } = store.state.user
  const hotjarData = {
    screen_url: window.location.href,
    user_profession: userInfo.profession_name ?? '',
    user_year_level: userInfo.year_level_name ?? '',
    user_is_admin: userInfo.is_admin ?? false,
    user_id: userInfo.id ?? null,
    user_is_logged_in: isLogin ?? false,
    prakerja_user: userInfo.prakerja_id ? 'Prakerja User' : 'Non-Prakerja User'
  }
  if (window.hj) {
    window.hj('identify', hotjarData.user_id, hotjarData)
  }
}, 600)

Vue.mount('#app')
